import styled from 'styled-components'
import { Tip } from './elements/Tip'

export const Container = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  display: flex;
  width: 100%;
  height: 332px;
  max-width: 744px;
  border-radius: 12px;
  position: relative;
`

export const TipIcon = styled(Tip)<{ $tipPosition: number; $tipBackgroundColor?: string }>`
  position: absolute;
  left: -13px;
  color: ${({ theme, $tipBackgroundColor }) => $tipBackgroundColor || theme.background};
  top: ${({ $tipPosition }) => $tipPosition}px;
`

export const WidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
`

export const WidgetBox = styled.div`
  flex: 1;
`
